import type { InputProps, InternalInputProps } from '../internal/input';
import Input from '../internal/input';

export type TextInputProps = InputProps & InternalInputProps;

export default Input;
